import CloseIcon from '@mui/icons-material/Close'
import { Box, Stack, Typography, useTheme } from '@mui/material'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { ISlotInfo } from '../../../_models/newBookingInterface'
import { StyledChip } from '../../../components/@extended/customChip'
import { MoonIcon, SunIcon, SunRiseIcon, SunSetIcon } from '../../../components/icons'

interface IProps {
  slotInfo: ISlotInfo
  onSlotDeselect: () => void
}
const SelectedSlot = (props: IProps) => {
  const { slotInfo, onSlotDeselect } = props
  const { slotId, slotTime, slotInterval } = slotInfo
  const { t } = useTranslation()
  const theme = useTheme()

  // Helper function to determine time interval based on slot time
  const getTimeIntervalFromSlotTime = (slotTime: string) => {
    if (!slotTime) return

    const hour = moment(slotTime.split(' - ')[0], 'hh:mm A').hour()
    if (hour >= 6 && hour < 12) return 'morning'
    if (hour >= 12 && hour < 18) return 'afternoon'
    if (hour >= 18 && hour < 24) return 'evening'
    return 'night'
  }
  // Use slotInterval if available, otherwise calculate from slotTime
  const timeInterval = slotInterval || getTimeIntervalFromSlotTime(slotTime || '')
  return (
    <div>
      <>
        <Typography mt={2} variant='subtitle1' color='table.light'>
          {t('newBooking.pickSlotTitle')}
        </Typography>
        <Stack
          spacing={2}
          direction={'row'}
          sx={{
            [theme.breakpoints.down(430)]: {
              display: 'block',
            },
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <Box mr={1} mt={1}>
              {timeInterval === 'morning' && (
                <SunRiseIcon
                  fill='none'
                  stoke={theme.palette.toggleButtonGroup.contrastText}
                  width='24'
                  height='24'
                />
              )}
              {timeInterval === 'afternoon' && (
                <SunIcon
                  fill='none'
                  stoke={theme.palette.toggleButtonGroup.contrastText}
                  width='24'
                  height='24'
                />
              )}
              {timeInterval === 'evening' && (
                <SunSetIcon
                  fill={'none'}
                  stoke={theme.palette.toggleButtonGroup.contrastText}
                  width='24'
                  height='24'
                />
              )}
              {timeInterval === 'night' && (
                <MoonIcon
                  fill={theme.palette.toggleButtonGroup.contrastText}
                  width='24'
                  height='24'
                />
              )}
            </Box>
            <Typography variant='subtitle2' color='toggleButtonGroup.contrastText' mt={1}>
              {timeInterval === 'morning' && t('newBooking.morningTitle')}
              {timeInterval === 'afternoon' && t('newBooking.afterNoonTitle')}
              {timeInterval === 'evening' && t('newBooking.eveningTitle')}
              {timeInterval === 'night' && t('newBooking.nightTitle')}
            </Typography>
          </Box>
          <StyledChip
            deleteIcon={<CloseIcon sx={{ color: `${theme.palette.common.white} !important` }} />}
            label={
              <Box display='flex'>
                <Typography variant='h5' fontSize={14} dir='ltr'>
                  {slotTime}
                </Typography>
              </Box>
            }
            key={slotId}
            onDelete={() => onSlotDeselect()}
            sx={{
              [theme.breakpoints.down(430)]: {
                marginLeft: '0px !important',
              },
            }}
          />
        </Stack>
      </>
    </div>
  )
}

export default SelectedSlot
